"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.flatToMdast = void 0;
const flatToMdast = (flat) => {
    const traverse = (index) => {
        const { idx: omit, ...node } = flat.nodes[index];
        if (node.children)
            node.children = node.children.map(traverse);
        return node;
    };
    const mdast = traverse(0);
    if (!mdast.children)
        mdast.children = [];
    if (flat.definitions instanceof Object) {
        for (const index of Object.values(flat.definitions)) {
            mdast.children.push(traverse(index));
        }
    }
    if (flat.footnoteOrder instanceof Array) {
        for (const index of flat.footnoteOrder) {
            mdast.children.push(traverse(index));
        }
    }
    return mdast;
};
exports.flatToMdast = flatToMdast;
